module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "titleWrap"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snippetTitleCopy),
      expression: "snippetTitleCopy"
    }],
    class: {
      edit: _vm.editing
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入标题",
      "disabled": !_vm.editing
    },
    domProps: {
      "value": (_vm.snippetTitleCopy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.snippetTitleCopy = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing && _vm.chooseLabelItem),
      expression: "!editing && chooseLabelItem"
    }],
    staticClass: "label green"
  }, [_vm._v(_vm._s(_vm.chooseLabelItem))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelfCodePage),
      expression: "isSelfCodePage"
    }]
  }, [_c('span', {
    staticClass: "last",
    on: {
      "click": function($event) {
        _vm.alertShow = true
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('span', {
    staticClass: "last",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.editOrDone))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    staticClass: "labelWrap"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v("请选择标签：")]), _vm._v(" "), _c('ul', _vm._l((_vm.labelListCopy), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "label green",
      class: {
        active: _vm.chooseLabelIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.chooseLabel(index, item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addLabelShow),
      expression: "addLabelShow"
    }],
    staticClass: "addColumn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addLabelInfo),
      expression: "addLabelInfo"
    }],
    ref: "addLabel",
    attrs: {
      "type": "text",
      "placeholder": "添加分类..."
    },
    domProps: {
      "value": (_vm.addLabelInfo)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addLabelSure($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addLabelInfo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addLabelSure
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('button', {
    staticClass: "more",
    on: {
      "click": _vm.addLabel
    }
  }, [_vm._v("添加")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "url"
  }, [_c('span', [_vm._v("访问地址：")]), _vm._v(" "), _c('span', {
    staticClass: "codeUrl"
  }, [_c('p', [_vm._v(_vm._s(_vm.codeUrl))])])]), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "info": "确认删除整个代码块？"
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": function($event) {
        _vm.alertShow = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-645630c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/code/codeTitle/codeTitle.vue
// module id = 274
// module chunks = 1